import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SearchService } from '@app/core/services/search/base.search.service';
import { SellingAgentsLogicService } from '@app/logic/selling-agents/sellingagents.logic.service';
import { SellingAgentsInputFindDialogDirective } from './sellingagents-input-find-dialog-directive';

interface IData {
    mappedItem: any;
    searchService: SearchService;
    extraSearchParams: { [key: string]: any };
    dialogHeading: string;
    contentHeading: string;
    placeholder: string;
}

@Component({
    selector: 'cb-sellingagents-input-find-dialog-cards',
    templateUrl: '../../input-find-dialog-cards/input-find-dialog-cards.component.html',
    styleUrls: ['../../input-find-dialog-cards/input-find-dialog-cards.component.scss'],
    providers: [SellingAgentsLogicService],
    standalone: false
})
export class SellingAgentsInputFindDialogCardsComponent extends SellingAgentsInputFindDialogDirective {
    constructor(
        public readonly dialogRef: MatDialogRef<SellingAgentsInputFindDialogDirective>,
        @Inject(MAT_DIALOG_DATA) public readonly data: IData,
        public logicService: SellingAgentsLogicService,
        public cdRef: ChangeDetectorRef
    ) {
        super(
            dialogRef,
            data,
            logicService,
            cdRef,
        );
    }
}

